class CaixaMistaBuilder extends HTMLElement {
  constructor() {
    super();

    this.size = parseInt(this.dataset.defaultSize || '12', 10);
    this.variants = {
      6: this.dataset.variant6,
      12: this.dataset.variant12
    };
    this.variantMediaIds = {
      6: this.dataset.variant6MediaId,
      12: this.dataset.variant12MediaId
    };
    this.sectionId = this.dataset.sectionId;

    this.flavors = {};
    this.flavorVariants = {};
    this.querySelectorAll('[data-flavor]').forEach((el) => {
      const flavor = el.dataset.flavor;
      this.flavors[flavor] = 0;
      this.flavorVariants[flavor] = el.dataset.variantId;
    });

    this.miniCart = document.querySelector('mini-cart');
    this.cartDrawer = document.querySelector('cart-drawer');

    console.log('[caixa-mista] init', JSON.stringify({
      defaultSize: this.dataset.defaultSize,
      variant6: this.dataset.variant6,
      variant12: this.dataset.variant12,
      flavorVariants: this.flavorVariants
    }, null, 2));

    this.bindEvents();
    this.update();
    this.syncPriceDisplay();
    this.syncGalleryMedia();
  }

  get total() {
    return Object.values(this.flavors).reduce((a, b) => a + b, 0);
  }

  get remaining() {
    return this.size - this.total;
  }

  get isComplete() {
    return this.total === this.size && this.size > 0;
  }

  bindEvents() {
    this.querySelectorAll('.cm-size').forEach((btn) => {
      btn.addEventListener('click', () => this.selectSize(btn));
    });

    this.querySelectorAll('[data-flavor]').forEach((card) => {
      const flavor = card.dataset.flavor;
      const minus = card.querySelector('[data-action="minus"]');
      const plus = card.querySelector('[data-action="plus"]');

      minus.addEventListener('click', () => {
        if (this.flavors[flavor] > 0) {
          this.flavors[flavor]--;
          this.update();
        }
      });

      plus.addEventListener('click', () => {
        if (this.remaining > 0) {
          this.flavors[flavor]++;
          this.update();
        }
      });
    });

    const form = this.querySelector('form');
    if (form) {
      form.addEventListener('submit', (e) => this.handleSubmit(e));
    }
  }

  selectSize(btn) {
    const newSize = parseInt(btn.dataset.size, 10);
    if (newSize === this.size) return;

    if (newSize < this.size && this.total > newSize) {
      Object.keys(this.flavors).forEach((f) => (this.flavors[f] = 0));
    }

    this.size = newSize;

    this.querySelectorAll('.cm-size').forEach((b) => {
      const isActive = b === btn;
      b.classList.toggle('is-active', isActive);
      b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    this.update();
    this.syncPriceDisplay();
    this.syncGalleryMedia();
  }

  syncGalleryMedia() {
    const mediaId = this.variantMediaIds[this.size];
    if (!mediaId || !this.sectionId) return;
    const gallery = document.querySelector(`media-gallery[id$="-${this.sectionId}"], media-gallery#MediaGallery-${this.sectionId}`)
      || document.querySelector('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
    gallery.setActiveMedia(`${this.sectionId}-${mediaId}`, true);
  }

  syncPriceDisplay() {
    const size = String(this.size);
    document.querySelectorAll('[data-cm-price-for]').forEach((el) => {
      el.hidden = el.dataset.cmPriceFor !== size;
    });
  }

  update() {
    this.querySelectorAll('[data-flavor]').forEach((card) => {
      const flavor = card.dataset.flavor;
      const qty = this.flavors[flavor];
      const qtyEl = card.querySelector('[data-cm-qty]');
      const minusBtn = card.querySelector('[data-action="minus"]');
      const plusBtn = card.querySelector('[data-action="plus"]');

      qtyEl.textContent = qty;
      card.classList.toggle('is-selected', qty > 0);
      minusBtn.disabled = qty === 0;
      plusBtn.disabled = this.remaining === 0;
    });

    const fill = this.querySelector('[data-cm-fill]');
    const percent = this.size > 0 ? (this.total / this.size) * 100 : 0;
    fill.style.width = `${Math.round(percent)}%`;

    const progressEl = this.querySelector('[data-cm-progress]');
    if (progressEl) {
      progressEl.setAttribute('aria-valuemax', this.size);
      progressEl.setAttribute('aria-valuenow', this.total);
    }

    const totalEl = this.querySelector('[data-cm-total]');
    const sizeEl = this.querySelector('[data-cm-size]');
    if (totalEl) totalEl.textContent = this.total;
    if (sizeEl) sizeEl.textContent = this.size;

    const variantInput = this.querySelector('[data-cm-variant-input]');
    if (variantInput) {
      const newVariantId = this.variants[this.size];
      if (newVariantId) variantInput.value = newVariantId;
    }

    this.updateCta();
  }

  updateCta() {
    const submit = this.querySelector('[data-cm-submit]');
    const text = this.querySelector('[data-cm-cta-text]');
    if (!submit || !text) return;

    if (this.isComplete) {
      submit.setAttribute('aria-disabled', 'false');
      text.textContent = 'Adicionar ao carrinho';
    } else {
      submit.setAttribute('aria-disabled', 'true');
      const word = this.remaining === 1 ? 'unidade' : 'unidades';
      if (this.total === 0) {
        text.textContent = `Selecione ${this.size} ${word} para continuar`;
      } else {
        text.textContent = `Faltam ${this.remaining} ${word}`;
      }
    }
  }

  buildItems() {
    const parentId = this.variants[this.size];
    if (!parentId) {
      throw new Error(`Variante da caixa de ${this.size} unidades não configurada (data-variant${this.size}).`);
    }

    const bundleId = `cm-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    const items = [{
      id: String(parentId),
      quantity: 1,
      properties: { _cm_bundle: bundleId, _cm_role: 'parent', _cm_size: String(this.size) }
    }];

    Object.entries(this.flavors).forEach(([name, qty]) => {
      if (qty <= 0) return;
      const variantId = this.flavorVariants[name];
      if (!variantId) {
        throw new Error(`Sabor "${name}" sem variant id. Verifique se o produto-sabor está publicado.`);
      }
      items.push({
        id: String(variantId),
        quantity: qty,
        properties: { _cm_bundle: bundleId, _cm_role: 'child' }
      });
    });

    return items;
  }

  async handleSubmit(e) {
    e.preventDefault();

    const submit = this.querySelector('[data-cm-submit]');
    if (!submit || submit.getAttribute('aria-disabled') === 'true') return;
    if (!this.isComplete) return;

    this.hideError();
    submit.classList.add('loading');
    submit.setAttribute('aria-disabled', 'true');

    let body;
    try {
      body = { items: this.buildItems() };
    } catch (err) {
      submit.classList.remove('loading');
      this.showError(err.message);
      this.updateCta();
      return;
    }

    if (this.miniCart && typeof this.miniCart.getSectionsToRender === 'function') {
      body.sections = this.miniCart.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }

    console.log('[caixa-mista] POST /cart/add.js', body);

    try {
      const response = await fetch(`${(window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add'}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        const message = data.description || data.message || 'Erro ao adicionar ao carrinho.';
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartError, { source: 'caixa-mista', errors: data.errors || message, message });
        }
        throw new Error(message);
      }

      this.resetSelection();

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'caixa-mista', cartData: data });
      }

      if (this.miniCart && typeof this.miniCart.renderContents === 'function') {
        if (this.miniCart.classList.contains('is-empty')) this.miniCart.classList.remove('is-empty');
        this.miniCart.renderContents(data);
      } else {
        window.location.href = (window.theme && theme.routes && theme.routes.cart_url) || '/cart';
      }
    } catch (err) {
      this.showError(err.message);
    } finally {
      submit.classList.remove('loading');
      this.updateCta();
    }
  }

  resetSelection() {
    Object.keys(this.flavors).forEach((f) => (this.flavors[f] = 0));
    this.update();
  }

  showError(message) {
    const wrapper = this.querySelector('.product-form__error-message-wrapper');
    const msg = this.querySelector('.product-form__error-message');
    if (wrapper && msg) {
      msg.textContent = message;
      wrapper.hidden = false;
    }
  }

  hideError() {
    const wrapper = this.querySelector('.product-form__error-message-wrapper');
    if (wrapper) wrapper.hidden = true;
  }
}

if (!customElements.get('caixa-mista-builder')) {
  customElements.define('caixa-mista-builder', CaixaMistaBuilder);
}
